import { 
  collection, 
  doc, 
  getDoc, 
  getDocs,
  query, 
  orderBy,
  limit,
} from 'firebase/firestore';
import { db } from '../../firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

// Race Results Service for Firestore operations
export const raceResultsService = {
  /**
   * Add race result (Admin function via Cloud Function)
   * @param {Object} raceData - Race result data
   * @returns {Promise<Object>} Result
   */
  addRaceResult: async (raceData) => {
    try {
      const addRaceResultFunction = httpsCallable(functions, 'addRaceResult');
      const result = await addRaceResultFunction(raceData);

      console.log('✅ Race result added:', result.data);
      return result.data;
    } catch (error) {
      console.error('❌ Error adding race result:', error);
      throw error;
    }
  },

  /**
   * Get latest race result
   * @returns {Promise<Object|null>} Latest race result or null
   */
  getLatestRaceResult: async () => {
    try {
      const resultsQuery = query(
        collection(db, 'raceResults'),
        orderBy('createdAt', 'desc'),
        limit(1)
      );

      const querySnapshot = await getDocs(resultsQuery);

      if (querySnapshot.empty) {
        console.log('ℹ️ No race results found');
        return null;
      }

      const resultDoc = querySnapshot.docs[0];
      const resultData = { id: resultDoc.id, ...resultDoc.data() };

      console.log('✅ Latest race result retrieved:', resultDoc.id);
      return resultData;
    } catch (error) {
      console.error('❌ Error getting latest race result:', error);
      throw error;
    }
  },

  /**
   * Get race result by ID
   * @param {string} raceId - Race identifier
   * @returns {Promise<Object|null>} Race result or null
   */
  getRaceResult: async (raceId) => {
    try {
      const resultRef = doc(db, 'raceResults', raceId);
      const resultDoc = await getDoc(resultRef);

      if (!resultDoc.exists()) {
        console.log('ℹ️ Race result not found:', raceId);
        return null;
      }

      return { id: resultDoc.id, ...resultDoc.data() };
    } catch (error) {
      console.error('❌ Error getting race result:', error);
      throw error;
    }
  },

  /**
   * Get all race results
   * @returns {Promise<Array>} Array of race results
   */
  getAllRaceResults: async () => {
    try {
      const resultsQuery = query(
        collection(db, 'raceResults'),
        orderBy('createdAt', 'desc')
      );

      const querySnapshot = await getDocs(resultsQuery);
      const results = [];

      querySnapshot.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() });
      });

      console.log('✅ Retrieved race results:', results.length);
      return results;
    } catch (error) {
      console.error('❌ Error getting all race results:', error);
      throw error;
    }
  },

  /**
   * Recalculate all points (Admin function)
   * @returns {Promise<Object>} Result
   */
  recalculateAllPoints: async () => {
    try {
      const recalculateFunction = httpsCallable(functions, 'recalculateAllPoints');
      const result = await recalculateFunction();

      console.log('✅ Points recalculated:', result.data);
      return result.data;
    } catch (error) {
      console.error('❌ Error recalculating points:', error);
      throw error;
    }
  },
};

export default raceResultsService;

